import { createGetEndpoint } from '@sonar-software/sonar-http';

import { MonitorFormTypes, SetupAuditTrailMonitor, UptimeMonitor } from '@types';

export type GetDataSecurityMonitorsByApplicationRequest = {
	applicationId: number;
};

export type GetDataSecurityMonitorFormTypes = Omit<MonitorFormTypes, 'enableOnWeekends' | 'monitoringWindow'> & {
	monitorConfig: Partial<UptimeMonitor> | SetupAuditTrailMonitor;
};

export type GetDataSecurityMonitorsByApplicationResponse = Array<GetDataSecurityMonitorFormTypes>;

export const getDataSecurityMonitorsByApplication = createGetEndpoint<
	GetDataSecurityMonitorsByApplicationRequest,
	GetDataSecurityMonitorsByApplicationResponse
>(({ applicationId }) => `/api/v3/data-security/applications/${applicationId}/monitors`);
